<div>
  <table mat-table class="full-width-table striped-table widget-table widget-table-hoverable widget-table-row" aria-label="Tasks">

    <ng-container matColumnDef="priority">
      <th mat-header-cell *matHeaderCellDef>Priority</th>
      <td mat-cell *matCellDef="let task">
        <mat-icon *ngIf="task.priority === 'High'"
          [matTooltip]="'FIDUCIARY.cockpit.task-widget.high-priority' | translate" svgIcon="prio" color="primary"></mat-icon>
      </td>
    </ng-container>

    <!-- Title Column -->
    <ng-container matColumnDef="title">
      <th mat-header-cell *matHeaderCellDef>Title</th>
      <td mat-cell *matCellDef="let task">
        <a *ngIf="task.source !== 'Sharepoint'"
          [routerLink]="['/', 'customer-spaces', customerSpaceId, 'fiduciary', 'tasks', task.id]"
          matTooltip="{{ task.title }}" matTooltipPosition="right">
          {{ task.title }}
        </a>
        <a *ngIf="task.source === 'Sharepoint'" href="{{ task.sharePointTaskUrl }}" target="_blank"
          matTooltip="{{ task.title }}" matTooltipPosition="right">
          {{ task.title }}
        </a>
      </td>
    </ng-container>

    <!-- Date Column -->
    <ng-container matColumnDef="dueOn">
      <th mat-header-cell *matHeaderCellDef>DueOn</th>
      <td mat-cell *matCellDef="let task">
        <span [class.text-primary]="isOverdue(task.dueOn)">
          {{ task.dueOn | date: 'dd.MM.yyyy' }}
        </span>
      </td>
    </ng-container>

    <!-- <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr> -->
    <tr mat-row *matRowDef="let row; columns: displayedColumns;" (click)="onRowClick($event, row)"></tr>
  </table>
</div>